<template>
<div>
  <div v-for="item in list" @click="goDetail(item.id)">{{item.name}}</div>

</div>
</template>

<script>
import { GetCaseList} from "@/http/api";
export default {
  name: "index",
  data(){
    return{
      list:[]
    }
  },
  mounted() {
    GetCaseList({orderBy:["im_chaosong_at", "desc"],doctor_id:1}).then(res=>{
      this.list = res.data.data
    })
  },
  methods:{
    goDetail(id){
      this.$router.push({
        path:'/case',
        query:{
          id:id
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
